import React from "react";
import styles from "./saveButton.module.css";
import Button from "../../common/Button";

const SaveButton = ({ firstButtonArgs,secondButtonArgs,  buttonArgs ={} }) => {
    return <>
        <div  className={styles.horiztonalline}></div>
        <div className={styles.formGroup} style={{display:"flex", width:"100%",justifyContent:"flex-end"}}>
            {firstButtonArgs?.label&&<Button {...firstButtonArgs} buttonOverrideStyle={styles.primaryButton}  >{firstButtonArgs?.label}</Button>}
            {secondButtonArgs?.label&&<Button {...secondButtonArgs} buttonOverrideStyle={styles.secondaryButton} >{secondButtonArgs?.label}</Button>}
         </div>
         </>
    // );
}

export default SaveButton;
